/* This file is auto-generated from PageNames.cs. Do not modify manually. */
export enum PageNames {
  // ========================================
  // Stock file pages
  // ========================================
  StockItems = 'stockItems',
  Categories = 'categories',
  Uom = 'uom',
  Departments = 'departments',
  Customers = 'customers',
  Addresses = 'addresses',
  Vendors = 'vendors',
  Locations = 'locations',
  LocationTypes = 'locationTypes',
  Facility = 'facility',
  Building = 'building',
  Floor = 'floor',
  DisposeTo = 'disposeTo',
  // ========================================
  // Stock list / order pages
  // ========================================
  PickList = 'pickList',
  PurchaseOrders = 'purchaseOrders',
  SalesOrders = 'salesOrders',
  // ========================================
  // Stock transaction pages
  // ========================================
  CheckoutTransactions = 'checkout-transactions',
  CheckinTransactions = 'checkin-transactions',
  TransactionReceive = 'transaction-receive',
  TransactionMove = 'transaction-move',
  TransactionIssue = 'transaction-issue',
  TransactionDispose = 'transaction-dispose',
  TransactionReturn = 'transaction-return',
  TransactionPack = 'transaction-pack',
  TransactionShip = 'transaction-ship',
  TransactionAdjustInventory = 'transaction-adjust-inventory',
  TransactionPhysicalInventory = 'transaction-physical-inventory',
  Breakdown = 'breakdown',
  StockAdjustAuthorizationTransaction = 'stockAdjustAuthorizationTransaction',
  StockDisposeAuthorizationTransaction = 'stockDisposeAuthorizationTransaction',
  StockCycleCountTransactions = 'stockcyclecount-transactions',
  StockCycleCountAdjustTransactions = 'stockcyclecountadjust-transactions',
  StockCycleCount = 'stockcyclecount-transactions',
  StockCycleCountAdjust = 'stockcyclecountadjust-transactions',
  // Alternate names for transaction pages (legacy)
  ReceiveTransactions = 'receive-transactions',
  MoveTransactions = 'move-transactions',
  IssueTransactions = 'issue-transactions',
  DisposeTransactions = 'dispose-transactions',
  ReturnTransactions = 'return-transactions',
  PackTransactions = 'pack-transactions',
  ShipTransactions = 'ship-transactions',
  KittingTransactions = 'kitting-transactions',
  StockAdjust = 'StockAdjust',
  StockPhysicalInventoryTransaction = 'stockPhysicalInventoryTransaction',
  BreakdownTransactions = 'breakdown-transactions',
  // ========================================
  // Stock history pages
  // ========================================
  ReceiveHistory = 'receiveHistory',
  CheckinTransactionsHistory = 'checkin-transactions-history',
  CheckoutTransactionsHistory = 'checkout-transactions-history',
  MoveHistory = 'moveHistory',
  IssueHistory = 'issueHistory',
  DisposeHistory = 'disposeHistory',
  ReturnHistory = 'returnHistory',
  PackHistory = 'packHistory',
  ShipHistory = 'shipHistory',
  AdjustInventoryHistory = 'adjustInventoryHistory',
  AssembleHistory = 'assembleHistory',
  BreakdownHistory = 'breakdownHistory',
  StockBreakdownHistory = 'stock-breakdown-history',
  StockPhysicalInventoryHistory = 'stockPhysicalInventoryHistory',
  StockDisposeAuthorizationHistory = 'stockdispose-authorization-history',
  StockAdjustAuthorizationHistory = 'stockadjust-authorization-history',
  StockCycleCountHistory = 'stockcyclecount-history',
  StockCycleCountAdjustHistory = 'stockcyclecountadjust-history',
  // ========================================
  // Stock top-level / other pages
  // ========================================
  History = 'history',
  Inventories = 'inventories',
  StockImport = 'stock-import',
  StockDisposeReport = 'stockDisposeReport',
  // ========================================
  // Asset file pages
  // ========================================
  Assets = 'assets',
  AssetModels = 'asset-models',
  AssetModels2 = 'asset-models-2',
  AssetTypes = 'asset-types',
  Conditions = 'conditions',
  FundingSource = 'fundingsource',
  Statuses = 'statuses',
  // ========================================
  // Asset transaction pages
  // ========================================
  AssetReservation = 'asset-reservation',
  AssetCheckinTransaction = 'assetcheckin-transaction',
  AssetCheckoutTransactions = 'assetcheckout-transactions',
  AssetDisposeTransactions = 'assetdispose-transactions',
  AssetReceiveTransactions = 'assetreceive-transactions',
  AssetMoveTransactions = 'assetmove-transactions',
  AssetCycleCountTransactions = 'assetcyclecount-transactions',
  AssetCycleCountAdjustTransactions = 'assetcyclecountadjust-transactions',
  AssetPhysicalInventoryTransactions = 'assetphysicalinventory-transactions',
  AssetDepreciationTransactions = 'assetdepreciation-transactions',
  AssetAdjustTransaction = 'assetadjust-transactions',
  AssetAdjustAuthorization = 'assetadjust-authorization',
  AssetDisposeAuthorization = 'assetdispose-authorization',
  // ========================================
  // Asset history pages
  // ========================================
  AssetAllHistory = 'asset-all-history',
  AssetMoveTransactionsHistory = 'assetmove-transactions-history',
  AssetCheckoutTransactionsHistory = 'assetcheckout-transactions-history',
  AssetCheckinTransactionsHistory = 'assetcheckin-transactions-history',
  AssetDisposeTransactionsHistory = 'assetdispose-transactions-history',
  AssetDisposeAuthorizationHistory = 'assetdispose-authorization-history',
  AssetAdjustAuthorizationHistory = 'assetadjust-authorization-history',
  AssetEditLog = 'asset-edit-log',
  AssetReceiveTransactionsHistory = 'assetreceive-transactions-history',
  AssetPhysicalInventoryHistory = 'assetphysicalinventory-history',
  AssetCycleCountHistory = 'assetcyclecount-history',
  AssetAdjustTransactionHistory = 'assetadjust-transactions-history',
  // ========================================
  // Asset top-level / other pages
  // ========================================
  AssetInventory = 'asset-inventory',
  AssetAccountsInventoryList = 'asset-accounts-inventory-list',
  AssetPurchaseOrders = 'asset-purchaseOrders',
  AssetPOPreferences = 'asset-po-preferences',
  AssetAllHistoryEnterprise = 'asset-all-history-enterprise',
  AssetImport = 'asset-import',
  // ========================================
  // Shared / cross-module pages
  // ========================================
  Files = 'files',
  Documents = 'documents',
  Videos = 'videos',
  ReportReports = 'report-reports',
  ReportForecast = 'report-forecast',
  BarcodeLabel = 'barcode-label',
  BarcodeCatalog = 'barcode-catalog',
  PrePrintedLabel = 'pre-printed-label',
  BarcodeGenerators = 'barcodeGenerators',
  // ========================================
  // Asset additional pages
  // ========================================
  Asset = 'Asset',
  ModelClass = 'ModelClass',
  AcquisitionType = 'AcquisitionType',
  DepreciationMethod = 'DepreciationMethod',
  AssetMobileDeviceSettings = 'AssetMobileDeviceSettings',
  AssetAuthorizationSetting = 'assetAuthorizationSetting',
  AssetAdjustSettings = 'assetadjust-settings',
  AccountAssetInventory = 'account-assetInventory',
  AccountAssetHistory = 'account-assetHistory',
  // ========================================
  // System / admin pages
  // ========================================
  Users = 'users',
  Accounts = 'Accounts',
  Dashboard = 'Dashboard',
  Settings = 'Settings',
  AppRoles = 'appRoles',
  Transfer = 'Transfer',
  Sites = 'sites',
  Persons = 'persons',
  CustomerTypes = 'customerTypes',
  AdvancedExpirationDate = 'AdvancedExpirationDate',
  AlertStockExpiration = 'Alert_StockExpiration',
  All = 'All',
  Reports = 'reports',
  Forecast = 'forecast',
  SysReceives = 'sysReceives',
  SysIssues = 'sysIssues',
  AvailableTraining = 'availableTraining',
  PaymentInformation = 'paymentInformation',
  SubscriptionEndOfLife = 'subscriptionEndOfLife',
  SupportEndOfLife = 'supportEndOfLife',
  LocationNotes = 'LocationNotes',
  PersonNotes = 'PersonNotes',
  SupplierNotes = 'SupplierNotes',
  // ========================================
  // Stock refactored module pages
  // ========================================
  Analytics = 'analytics',
  CustomerNotes = 'CustomerNotes',
  StockNotes = 'StockNotes',
  CheckInTransactionsHistory = 'checkin-transactions-history',
  CheckOutTransactionsHistory = 'checkout-transactions-history',
  PerformedMaintenanceHistory = 'performedMaintenanceHistory',
  StockEditLog = 'stock-edit-log',
  StockTransferHistory = 'stock-transfer-history',
  EnterpriseInventories = 'enterprise_inventories',
  StockVideos = 'stockVideos',
  StockList = 'stockList',
  ListNotes = 'ListNotes',
  PicklistNotes = 'PicklistNotes',
  ScheduleMaintenance = 'schedule-maintenance',
  MaintenanceType = 'maintenance-type',
  SalesOrderNotes = 'SalesOrderNotes',
  SoToPoPreferences = 'so-to-po-preferences',
  StockPurchaseOrderNotes = 'StockPurchaseOrderNotes',
  AccountInformation = 'accountInformation',
  ChangePassword = 'ChangePassword',
  ShoppingCartSalesOrder = 'shoppingCartSalesOrder',
  AssembleTransactions = 'assemble-transactions',
  StockPhysicalInventoryAdjust = 'stockPhysicalInventoryAdjust',
  StockPhysicalInventoryCount = 'stockPhysicalInventoryCount',
  DisassembleTransactions = 'disassemble-transactions',
  PerformMaintenance = 'perform-maintenance',
  PhysicalInventoryTransaction = 'physicalInventory-Transaction',
  StockReservation = 'stock-reservation',
  TransferRequests = 'transferRequests',
  AdjustReceiveCost = 'adjustReceiveCost',
  StockToAsset = 'stockToAsset',
  SiteTransfers = 'site-transfers',
  SiteTransferOut = 'site-transfer-out',
  SiteTransferIn = 'site-transfer-in',
  SiteTransferHistory = 'siteTransferHistory',
  //settings pages
  StockCycleCountSettings = 'stockcyclecount-settings',
  // ========================================
  // Helper: resolve string name from Pages enum
  // ========================================
}
